import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const VendorPersonalInformation = () => {
    return (
        <div className="vendor-personal-information-wrapper xmt-16 xmt-lg-20">
            <div className="info-title">
                <h2 className="title">اطلاعات شخصی</h2>
            </div>
            <div className="inputs-box">
                <div className="row">
                    <div className="col-xl-5 col-md-6">
                        <input type="text" className="input-personal-info" placeholder="نام"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <input type="text" className="input-personal-info xmt-6 xmt-md-0" placeholder="نام خانوادگی"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <input type="number" className="input-personal-info xmt-6" placeholder="کد ملی"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <input type="text" className="input-personal-info xmt-6" placeholder="شماره شناسنامه"/>
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <div className="select-input position-relative">
                            <select className="form-select input-personal-info xmt-6">
                                <option value="default">جنسیت</option>
                                <option>مرد</option>
                                <option>زن</option>
                            </select>
                            <IconName name="expand_more" className="icon position-absolute more-icon"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="birthday-select">
                <h4 className="title">تاریخ تولد</h4>
                <div className="select-boxes d-flex align-items-center persian-number">
                    <div className="select position-relative">
                        <select className="form-select input-personal-info">
                            <option value="default">روز</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                            <option>6</option>
                            <option>7</option>
                            <option>8</option>
                            <option>9</option>
                            <option>10</option>
                            <option>11</option>
                            <option>12</option>
                            <option>13</option>
                            <option>14</option>
                            <option>15</option>
                            <option>16</option>
                            <option>17</option>
                            <option>18</option>
                            <option>19</option>
                            <option>20</option>
                            <option>21</option>
                            <option>22</option>
                            <option>23</option>
                            <option>24</option>
                            <option>25</option>
                            <option>26</option>
                            <option>27</option>
                            <option>28</option>
                            <option>29</option>
                            <option>30</option>
                        </select>
                        <IconName name="expand_more" className="icon position-absolute more-icon"/>
                    </div>
                    <div className="select position-relative">
                        <select className="form-select input-personal-info xmr-3 xmr-md-6">
                            <option value="default">ماه</option>
                            <option>فروردین</option>
                            <option>اردیبهشت</option>
                            <option>خرداد</option>
                            <option>تیر</option>
                            <option>مرداد</option>
                            <option>شهریور</option>
                            <option>مهر</option>
                            <option>آبان</option>
                            <option>آذر</option>
                            <option>دی</option>
                            <option>بهمن</option>
                            <option>اسفند</option>
                        </select>
                        <IconName name="expand_more" className="icon position-absolute more-icon"/>
                    </div>
                    <div className="select position-relative">
                        <select className="form-select input-personal-info xmr-3 xmr-md-6">
                            <option value="default">سال</option>
                            <option>1390</option>
                            <option>1389</option>
                            <option>1388</option>
                            <option>1387</option>
                            <option>1386</option>
                            <option>1385</option>
                            <option>1384</option>
                            <option>1383</option>
                        </select>
                        <IconName name="expand_more" className="icon position-absolute more-icon"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorPersonalInformation;
